export const DEFAULT_FLAVOUR = 'full'
export const FLAVOURS = ['full', 'semi', 'skimmed', 'archive']
export const FLAVOUR_TITLES = {
  full: 'Full Fat',
  semi: 'Semi-Skimmed',
  skimmed: 'Skimmed',
  archive: 'Archive'
}
